import { watchBlockNumber } from 'viem/actions';
import { AbortError } from '../errors/base.js';
import { getOrder } from './getOrder.js';
import { parseInboxStatus } from './parseInboxStatus.js';
const terminalStatus = [
    'closed',
    'filled',
    'rejected',
];
export function waitForOrderClose(params) {
    const { pollingInterval, signal, ...getOrderParams } = params;
    if (signal?.aborted) {
        return Promise.reject(new AbortError('Aborted'));
    }
    return new Promise((resolve, reject) => {
        const onAbort = () => {
            stop();
            reject(new AbortError('Aborted'));
        };
        signal?.addEventListener('abort', onAbort, { once: true });
        const stop = watchBlockNumber(params.client, {
            onBlockNumber: async () => {
                const order = await getOrder(getOrderParams);
                const status = parseInboxStatus({ order });
                if (terminalStatus.includes(status)) {
                    stop();
                    signal?.removeEventListener('abort', onAbort);
                    resolve(status);
                }
            },
            onError: (err) => {
                stop();
                signal?.removeEventListener('abort', onAbort);
                reject(err);
            },
            pollingInterval,
        });
    });
}
//# sourceMappingURL=waitForOrderClose.js.map